import {register} from 'swiper/element/bundle';
import {environment} from "./environments/environment";
import {enableProdMode, importProvidersFrom} from "@angular/core";
import {bootstrapApplication} from "@angular/platform-browser";
import {AppComponent} from "./app/app.component";
import {provideRouter} from "@angular/router";
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {fr_FR, provideNzI18n} from "ng-zorro-antd/i18n";
import {IconModule} from "./app/shared/components/icon/icon.module";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {routes} from "./app/app-routing.module";
import {AkitaNgDevtools} from "@datorama/akita-ngdevtools";
import {registerLocaleData} from "@angular/common";
import fr from '@angular/common/locales/fr';

registerLocaleData(fr);
register();

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(
      withInterceptorsFromDi(),
    ),
    provideAnimationsAsync(),
    provideNzI18n(fr_FR),
    importProvidersFrom(
      IconModule,
      ...(environment.production ? [] : [AkitaNgDevtools.forRoot()])
    ),
    importProvidersFrom(BrowserAnimationsModule)
  ]
}).catch(err => console.error(err));
